<!-- New layout template -->
<div
  fxLayout="row"
  fxLayout.lt-md="column"
  fxLayoutAlign="space-between center"
  fxLayoutAlign.lt-md="start stretch"
  fxLayoutGap="12px"
  [style.marginBottom]="'16px'">
  <div
    fxLayout="row"
    fxLayout.lt-md="column"
    fxLayoutAlign="start start"
    fxLayoutAlign.lt-md="start stretch"
    fxLayoutGap="12px">
    <ng-container *ngTemplateOutlet="activitySearchTemplate"></ng-container>
    <ng-container
      *ngIf="isFlexAdmin"
      [ngTemplateOutlet]="teacherSearchTemplate"></ng-container>
  </div>
  <ng-container *ngTemplateOutlet="createButtonTemplate"></ng-container>
</div>
<ng-container
  *ngIf="(isLoading$ | async) === false && showEmptyState; else mainContent"
  [ngTemplateOutlet]="noResults"></ng-container>

<div
  *ngIf="isLoading$ | async"
  class="tw-mt-4">
  <mg-spinner
    [diameter]="40"
    [thickness]="3">
  </mg-spinner>
</div>

<!-- Main Content -->
<ng-template #mainContent>
  <div class="activities">
    <mat-table
      class="list-table list-table-dashed"
      matSort
      [fxHide]="isLoading$ | async"
      [dataSource]="dataSource"
      [trackBy]="trackByFn">
      <!-- Icon Column -->
      <ng-container matColumnDef="icon">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let item">
          <mg-ftm-activity-img
            [bannerImage]="item.bannerImage"
            [imagePath]="item.imagePath">
          </mg-ftm-activity-img>
        </mat-cell>
      </ng-container>

      <!-- Activity Name Column -->
      <ng-container matColumnDef="name">
        <mat-header-cell
          *matHeaderCellDef
          mgSortHeader
          mat-sort-header
          class="w-sm-flex"
          [activeColumnKey]="activeSortColumn$ | async"
          (click)="selectActiveColumn('name')">
          <mg-text
            class="column-header"
            variant="body-xs-secondary"
            color="grey-300">
            {{ MESSAGES.TABLE_NAME }}
          </mg-text>
        </mat-header-cell>
        <mat-cell
          *matCellDef="let item"
          class="w-sm-flex">
          <mg-text
            variant="body"
            matTooltipClass="mg-tooltip"
            [matTooltip]="item.name"
            [numberOfLines]="2"
            >{{ item.name }}
          </mg-text>
        </mat-cell>
      </ng-container>

      <!-- Teachers Column -->
      <ng-container
        matColumnDef="teachers"
        class="text-right">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell
          *matCellDef="let item"
          class="text-right">
          <mg-icon
            matTooltipClass="mg-tooltip"
            [matTooltip]="
              (item | additionalTeachers) === null ? '' : 'Activity teachers:\n' + (item | additionalTeachers)
            "
            [iconName]="(item | additionalTeachers) === null ? 'mg-person' : 'mg-group-menu'">
          </mg-icon>
        </mat-cell>
      </ng-container>

      <!-- First Name Column -->
      <ng-container matColumnDef="createdByPerson.firstName">
        <mat-header-cell
          *matHeaderCellDef
          mgSortHeader
          mat-sort-header
          class="w-sm-flex"
          [activeColumnKey]="activeSortColumn$ | async"
          (click)="selectActiveColumn('titcreatedByPerson.firstNamele')">
          <mg-text
            class="column-header"
            variant="body-xs-secondary"
            color="grey-300">
            {{ MESSAGES.TABLE_TEACHER_FIRST_NAME }}
          </mg-text>
        </mat-header-cell>
        <mat-cell
          *matCellDef="let item"
          class="w-sm-flex">
          <mg-text
            variant="body"
            matTooltipClass="mg-tooltip"
            [matTooltip]="item.createdByPerson.firstName"
            [numberOfLines]="2"
            >{{ item.createdByPerson.firstName }}</mg-text
          >
        </mat-cell>
      </ng-container>

      <!-- Last Name Column -->
      <ng-container matColumnDef="createdByPerson.lastName">
        <mat-header-cell
          *matHeaderCellDef
          mgSortHeader
          mat-sort-header
          class="w-sm-flex"
          [activeColumnKey]="activeSortColumn$ | async"
          (click)="selectActiveColumn('createdByPerson.lastName')">
          <mg-text
            class="column-header"
            variant="body-xs-secondary"
            color="grey-300">
            {{ MESSAGES.TABLE_TEACHER_LAST_NAME }}
          </mg-text>
        </mat-header-cell>
        <mat-cell
          *matCellDef="let item"
          class="w-sm-flex">
          <mg-text
            variant="body"
            matTooltipClass="mg-tooltip"
            [matTooltip]="item.createdByPerson.lastName"
            [numberOfLines]="2"
            >{{ item.createdByPerson.lastName }}</mg-text
          >
        </mat-cell>
      </ng-container>

      <!-- Location Column -->
      <ng-container matColumnDef="location">
        <mat-header-cell *matHeaderCellDef>
          <mg-text
            class="column-header"
            variant="body-xs-secondary"
            color="grey-300">
            {{ MESSAGES.TABLE_LOCATION }}
          </mg-text>
        </mat-header-cell>
        <mat-cell *matCellDef="let item">
          <mg-text
            variant="body"
            matTooltipClass="mg-tooltip"
            [matTooltip]="item.location"
            [numberOfLines]="2"
            >{{ item.location }}</mg-text
          >
        </mat-cell>
      </ng-container>

      <!-- Seats Column -->
      <ng-container matColumnDef="seats">
        <mat-header-cell *matHeaderCellDef>
          <mg-text
            class="column-header"
            variant="body-xs-secondary"
            color="grey-300">
            {{ MESSAGES.TABLE_REGISTRATION_LIMIT }}
          </mg-text>
        </mat-header-cell>
        <mat-cell *matCellDef="let item">
          <mg-text
            *ngIf="item.registrationLimit; else unlimitedIconTemplate"
            variant="body"
            [numberOfLines]="2">
            {{ item.registrationLimit }}
          </mg-text>
          <ng-template #unlimitedIconTemplate>
            <mg-icon
              matTooltipClass="mg-tooltip"
              [matTooltip]="MESSAGES.TABLE_REGISTRATION_UNLIMITED_LABEL"
              >mg-infinity</mg-icon
            >
          </ng-template>
        </mat-cell>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="buttons">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let item">
          <mg-btn
            class="tw-mr-2"
            variant="icon"
            iconSet="minga"
            icon="mg-copy"
            (pressed)="copyItem(item)">
          </mg-btn>
          <mg-btn
            variant="icon"
            iconSet="minga"
            icon="mg-edit"
            (pressed)="openEditModal(item)">
          </mg-btn>
        </mat-cell>
      </ng-container>

      <!-- Mobile Column -->
      <ng-container matColumnDef="mobile">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell
          *matCellDef="let item"
          class="mobile-layout">
          <mg-mobile-card [title]="item.name">
            <div class="tw-flex tw-flex-column tw-gap-1">
              <div class="tw-flex tw-flex-row tw-justify-between tw-mt-2">
                <mg-text
                  variant="body-sm"
                  color="surface-alt">
                  {{ MESSAGES.TABLE_TEACHER_NAME }}
                </mg-text>
                <mg-text variant="body-sm">
                  {{ item.createdByPerson.name }}
                </mg-text>
              </div>
              <div class="tw-flex tw-flex-row tw-justify-between">
                <mg-text
                  variant="body-sm"
                  color="surface-alt">
                  {{ MESSAGES.TABLE_LOCATION }}
                </mg-text>
                <mg-text variant="body-sm"> {{ item.location }}</mg-text>
              </div>
              <div class="tw-flex tw-flex-row tw-justify-between">
                <mg-text
                  variant="body-sm"
                  color="surface-alt">
                  {{ MESSAGES.TABLE_REGISTRATION_LIMIT }}
                </mg-text>
                <mg-text variant="body-sm">
                  {{ item.registrationLimit || MESSAGES.TABLE_REGISTRATION_UNLIMITED_LABEL }}
                </mg-text>
              </div>
              <div class="tw-flex tw-flex-row tw-justify-between">
                <mg-btn
                  variant="icon"
                  iconSet="minga"
                  icon="mg-copy"
                  (pressed)="copyItem(item)">
                </mg-btn>
                <mg-btn
                  variant="icon"
                  iconSet="minga"
                  icon="mg-edit"
                  (pressed)="openEditModal(item)">
                </mg-btn>
              </div>
            </div>
          </mg-mobile-card>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns$ | async"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns$ | async"> </mat-row>
    </mat-table>

    <!-- Paginator -->
    <div
      class="paginator-container tw-mt-4"
      [fxHide]="(isLoading$ | async) === true || showEmptyState">
      <mg-paginator> </mg-paginator>
    </div>
  </div>
</ng-template>

<!-- Empty State Template -->
<ng-template #noResults>
  <div class="activities-empty">
    <mg-empty-state [title]="dataSource.data?.length === 0 ? MESSAGES.NO_ACTIVITIES : MESSAGES.NO_FILTERED_ACTIVITIES">
    </mg-empty-state>
  </div>
</ng-template>

<!-- Teacher Search Search Template -->
<ng-template #teacherSearchTemplate>
  <mg-form-select
    mgTeacherSearch
    appendTo="body"
    placeholder="Teacher"
    class="search-input"
    [closeOnSelect]="true"
    [multiple]="false"
    [searchable]="true"
    [hideSelected]="false"
    [floatingLabel]="false"
    [isClearable]="true"
    [value]="(queryParams$ | async)?.teacher_hash || null"
    (selectionChanged)="onTeacherSelectChange($any($event))">
  </mg-form-select>
</ng-template>

<!-- Activity Name Search Template -->
<ng-template #activitySearchTemplate>
  <mg-form-text-input
    class="search-input"
    label="Search by title"
    iconRight="search"
    [isClearable]="true"
    [value]="(queryParams$ | async)?.title"
    (valueChange)="setSearchTitle($event)">
  </mg-form-text-input>
</ng-template>

<!-- Create Activity Button Template -->
<ng-template #createButtonTemplate>
  <div
    class="create-button"
    fxFlex="noshrink"
    fxFlex.gt-sm="nogrow">
    <mg-btn
      variant="filled"
      [wide]="true"
      [responsive]="true"
      (pressed)="openEditModal({})">
      {{ MESSAGES.CREATE_ACTIVITY }}
    </mg-btn>
  </div>
</ng-template>
